import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState, useCallback, useRef } from 'react';
import { shape, string, arrayOf, func, bool } from 'prop-types';
import AttributeBase from '../AttributeBase';
import AttributeSelect from '../AttributeSelect';

const AttributeVolume = ({
  attribute,
  variations,
  onChange,
  alignment,
  fullWidth
}) => {
  const [visible, setVisible] = useState(false);
  const attributes = useRef();
  const handleOnChange = useCallback((e, variation) => {
    onChange(e, variation);
    attributes.current.blur();
  }, [visible]);
  return /*#__PURE__*/React.createElement(AttributeBase, _extends({}, attribute, {
    onClick: () => setVisible(!visible),
    onBlur: () => setVisible(false),
    alignment: alignment,
    ref: attributes,
    bordered: true
  }), !!visible && /*#__PURE__*/React.createElement(AttributeSelect, _extends({}, attribute, {
    fullWidth: fullWidth,
    variations: variations,
    onChange: handleOnChange,
    onClose: () => setVisible(false)
  })));
};

AttributeVolume.defaultProps = {
  attribute: {},
  disabled: false,
  variations: [],
  alignment: ''
};
process.env.NODE_ENV !== "production" ? AttributeVolume.propTypes = {
  attribute: shape({
    label: string,
    type: string,
    current: string,
    selected: bool,
    values: arrayOf(string)
  }),
  disabled: bool,
  variations: arrayOf(shape({
    image: string,
    label: string,
    type: string,
    value: string,
    id: string
  })),
  onChange: func,
  alignment: string,
  fullWidth: bool
} : void 0;
export default AttributeVolume;